<template>
  <custom-callout class-main="mt-3 rounded" :has-toggle="false">
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col col-sm-3 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Nombre:</div>
        <div class="color-black font-16">
          {{ data.fullName | empty }}
        </div>
      </div>
      <div class="col col-sm-3 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Número de Seguro Social:</div>
        <div class="color-black font-16">
          {{ data.ssn | empty }}
        </div>
      </div>
      <div class="col col-sm-3 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Especialidades:</div>
        <div class="color-black font-16">
          {{ data.specialties | empty }}
        </div>
      </div>
      <div
        v-if="showAction"
        class="col col-sm col-12 d-flex align-items-center justify-content-end"
      >
        <action-button
          i="fas fa-check"
          text="Seleccionar"
          variant="outline-success"
          @click="$emit('on-select-specialist')"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

export default {
  name: 'SpecialistForSuperviseResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showAction: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {},
};
</script>
